import { type HandleSubProcessActionConfig, TooltipText } from '@lighthouse/shared'
import { useAtomValue } from 'jotai'
import React, { useMemo } from 'react'

import { workflowListAtom } from '@/atoms/workflow/state'

import { typeName } from '../../../OutputVariable'
import * as CM from '../styles'
import * as SC from './styles'

type HandleSubProcessActionConfigProps = {
    config: HandleSubProcessActionConfig
}

const HandleSubProcessCard: React.FC<HandleSubProcessActionConfigProps> = ({ config }) => {
    const { args, subProcessId } = config

    const workflows = useAtomValue(workflowListAtom)

    const subProcessName = useMemo(() => {
        const workflow = workflows.find(item => item.id === subProcessId)
        return workflow?.name
    }, [workflows, subProcessId])

    if (!subProcessId) {
        return null
    }

    if (!subProcessName && !args.length) {
        return null
    }

    return (
        <CM.CardItemContainer>
            {subProcessName && (
                <>
                    <SC.TypeName>执行的子流程</SC.TypeName>

                    <CM.FieldList>
                        <CM.FieldItem style={{ justifyContent: 'flex-start' }}>
                            <SC.FieldItemIcon>
                                <SC.Icon type="Reorder" />
                            </SC.FieldItemIcon>
                            <TooltipText
                                title={subProcessName}
                                render={ref => (
                                    <SC.FieldItemRightTitle ref={ref} color="var(--color-gray-600)">
                                        {subProcessName}
                                    </SC.FieldItemRightTitle>
                                )}
                            />
                        </CM.FieldItem>
                    </CM.FieldList>
                </>
            )}

            {args.length > 0 && (
                <>
                    <SC.TypeName>子流程参数值设置</SC.TypeName>
                    <CM.FieldList>
                        {args.map(item => (
                            <CM.FieldItem key={item.id}>
                                <TooltipText
                                    title={item.name}
                                    render={ref => <CM.FieldItemTitle ref={ref}>{item.name}</CM.FieldItemTitle>}
                                />

                                <SC.FieldItemRightTitle style={{ width: 70 }}>{typeName(item.innerType)}</SC.FieldItemRightTitle>
                            </CM.FieldItem>
                        ))}
                    </CM.FieldList>
                </>
            )}
        </CM.CardItemContainer>
    )
}

export default HandleSubProcessCard
